import {
  Component,
  OnInit,
  Injector,
  OnDestroy,
  ViewEncapsulation,
  ViewChild,
} from "@angular/core";

import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
  ReactiveFormsModule,
} from "@angular/forms";

import { Router, ActivatedRoute } from "@angular/router";
const swal = require("sweetalert");
import * as ptLocale from "date-fns/locale/pt";
import { BehaviorSubject } from "rxjs";

import { CustomValidators } from "ng2-validation";
import { DatepickerOptions } from "ng2-datepicker";

import { List } from "lodash";

import { LoadingService } from "../../../../../util/loader.service";
import { Empresa } from "../../../../../models/empresa/empresa";
import { MultiplasLojasService } from "../../multiplas-lojas.service";
import { ImageCroppedEvent } from "ngx-image-cropper";

@Component({
  selector: "app-logo-empresa",
  templateUrl: "./logo-empresa.component.html",
  styleUrls: ["./logo-empresa.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class LogoEmpresaComponent implements OnInit {
  valForm: FormGroup;
  buttonType: any;
  

  router: Router;
  id: any;
  empresa: Empresa;
  edicao = false;
  imagem: any;

  imageChangedEvent: any = "";
  croppedImage: any = "";

  name: string;

  constructor(public loader: LoadingService, public service: MultiplasLojasService,  private route: ActivatedRoute,
    private routerNavigate: Router) {

    this.id = this.route.snapshot.paramMap.get("id");
  }

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }
  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    this.imagem = event.base64;
   // this.imagem = this.dataURLtoFile(event.base64, `iamgem.png`);

  }
  imageLoaded(image: HTMLImageElement) {
    // show cropper
  }
  cropperReady() {
    // cropper ready
  }
  loadImageFailed() {
    // show message
  }
  dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  submitForm($ev) {
    $ev.preventDefault();
    this.loader.show("body");

    this.service.uploadLogo(this.id,this.imagem).subscribe((result) => {
      debugger;
      this.loader.hide("body");
     
    });
  }

  ngOnInit() {}
}
